export default {
  loading: false,
  items: null,
  sliderItem: null,
  showSlider: false
}